import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
import { formatearFecha } from "../../../utilidades/formateos";
const apiUrl = process.env.REACT_APP_API_KEY_ADMIN
export const getPagoOperador = async (setDatos,filtros) => {
    Swal.fire({
        title: 'Cargando...',
        text: 'Obteniendo datos...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    })
    await api.get(`${apiUrl}/admin/get-pago-operadores?fecha_inicio=${formatearFecha(filtros.desde)}&fecha_fin=${formatearFecha(filtros.hasta)}&id_operador=${filtros.operador?.code?filtros.operador?.code:''}`)
        .then((res) => {
            Swal.close();
            setDatos(res.data)
        })
        .catch((error) => {
             Swal.close();
             Swal.fire({icon:"error",text:error})
            console.log('error', error);

        })

}